import { TimeTracker } from "./components/TimeTracker";
import "./index.css";

export function App() {
  return <TimeTracker />;
}

export default App;
